import React from 'react';

const EmpresaConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/empresa',
      component: React.lazy(() => import('./Empresa')),
    },
  ],
};

export default EmpresaConfig;
